import React from "react";
import styles from '../../styles/section/Main2.module.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';
import { useNavigate } from "react-router-dom";

// swiper css
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import '../../styles/section/CustomSwiper.css';

const pub = process.env.PUBLIC_URL;

const images = [
   `${pub}/main/2p/2p_01.png`,
   `${pub}/main/2p/2p_02.png`,
   `${pub}/main/2p/2p_03.png`,
];

const text = [
    ["은 플랫폼 회사로서", "오늘보다 더 성장하려는 기업을 돕습니다."],
    ["은 고객과 기업에게", "신뢰와 가치를 서비스 합니다."],
    ["은 고객과 기업에게", "도전과 혁신을 지원합니다."],
];

const Two = ( props ) => {

    const navigate = useNavigate();

    const navigateToService = () => {
        navigate("/services");
    };

    const navigateToContact = () => {
        navigate("/contact");
    };

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    //     }, 7000); // 7초마다 이미지 변경

    //     return () => clearInterval(interval); // 컴포넌트 언마운트 시 인터벌 제거
    // }, []);

    return (
        <div className={`${styles.section}`}>
            <Swiper
                slidesPerView={1}
                spaceBetween={30}
                centeredSlides={true}
                effect={'fade'}
                loop={true}
                autoplay={{
                    delay: 5500,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation, EffectFade]}
                className="mySwiper">
                
                {[0,1,2].map((index, el) => {
                    return (
                        <SwiperSlide>
                            <img src={images[index]} alt={`Slide ${index + 1}`} 
                                key={"img" + index}/>

                            <div className={`${styles.middleText} ${styles.gradientText}`}>
                                <p>Business Solution</p>
                                <p>Company</p>
                            </div>

                            <div className={`${styles.rightBox}`} key={"text" + index}>
                                <p><span className={`${styles.rightTextBold}`}>주식회사 오퍼그룹</span>{text[index][0]}</p>
                                <p>{text[index][1]}</p>
                            </div>

                            <div className={styles.buttons}>
                                <button 
                                    className={`${styles.button} ${styles.buttonWhite}`}
                                    onClick={navigateToService}
                                >서비스보기</button>
                                <button 
                                    className={`${styles.button} ${styles.buttonGray}`}
                                    onClick={navigateToContact}
                                >문의하기</button>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};

export default Two;